module.exports = __webpack_public_path__ + "static/kanjiverse-thumbnail-a2a7b58aecb3016e4ea3e1b4f213a0db.png";